<div class="dialog-container">
  <mat-card class="no-shadow">
    <mat-card-header>
      <mat-card-title class="no-subtitle">Standby List Info</mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <app-data-box headerTitle="Jumpseaters" class="mt-32">
        <div class="data-box-content">
          <ul>
            <li>
              Potential flight deck jumpseaters are shown in
              <span class="caution-color font-bold">orange</span> (FDJ AA, FDJ
              EAG, D6UJ).
            </li>
            <li>
              A standby assigned a flight deck jumpseat is shown in
              <span class="success-color font-bold">green</span>.
            </li>
            <li>
              A potential flight deck jumpseater assigned a cabin seat is
              displayed in
              <span class="font-bold">bold</span> with no color applied.
            </li>
          </ul>
        </div>
      </app-data-box>
      <app-data-box headerTitle="Filter Options" class="mt-32">
        <div class="data-box-content">
          <ul>
            <li>
              <span class="font-bold accent-color">Non-rev: </span> Show
              non-revenue standbys only.
            </li>
            <li>
              <span class="font-bold accent-color">Stby: </span> Show both revenue
              and non-revenue standbys.
            </li>
            <li>
              <span class="font-bold accent-color">All: </span> Show upgrades,
              revenue standbys, and non-revenue standbys.
            </li>
          </ul>
        </div>
      </app-data-box>
    </mat-card-content>
  </mat-card>
</div>